import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import limpiarIcon from '../Resources/svg/gl_delete_filled.svg'
import DetailItem from './detailItem'
import TabTitle from './tabTitle'
import { searchNameOfDocumentType } from '../Utils/utils'

const DetailsTab = ({ dataState, customerProfile, investmentPortfolio, list, onClick }) => {
    const [selected, setSelected] = useState(Object.keys(dataState)[1])
    const {recommended} = useSelector(state => state.recommended);
    const cmProfile = recommended ? recommended.investmentProfile : "";
    const asegurado = Object.values(dataState)[0]
    const contratante = Object.values(dataState)[1]
    const entriesAsegurado = Object.entries(dataState)[0]
    const fullnames = (dataValues) => dataValues.names ? `
  ${dataValues.names ? dataValues.names.toLowerCase() : ''} 
  ${dataValues.firstName ? dataValues.firstName.toLowerCase() : ''} 
  ${dataValues.lastName ? dataValues.lastName.toLowerCase() : ''}` : dataValues.companyName

    const { assured, contratant } = dataState

    const profileListCase = () => {
        if (
            assured != undefined &&
            contratant != undefined &&
            Object.keys(contratant).length > 0 &&
            Object.keys(assured).length > 0 &&
            Object.values(assured)[1] != Object.values(contratant)[1]
        ) {
            //Cuando existen asegurado y contratante
            return Object.keys(dataState).map((e, i) => {
                return (
                    dataState[e].names ? (
                        <div
                            key={`${e}-list-${i}`}
                            className={'detailsTab__listDetails'}
                        >
                            <DetailItem flag={dataState[e].clientType} />
                            <DetailItem
                                flag="Nombre: "
                                details={fullnames(dataState[e])}
                            />
                            <DetailItem
                                flag={`${searchNameOfDocumentType(dataState[e].typeDoc)}: `}
                                details={dataState[e].nroDoc}
                            />
                            <DetailItem
                                flag="Fecha de nacimiento: "
                                details={dataState[e].birthday}
                            />
                            {e === 'contratant' && (
                                <DetailItem
                                    flag="Perfil de inversión: "
                                    details={cmProfile}
                                />
                            )}
                            {
                                investmentPortfolio && (
                                    <DetailItem
                                        flag="Portafolio sugerido: "
                                        details={investmentPortfolio}
                                    />
                                )
                            }
                        </div>
                    ) : (
                        <div
                            key={`${e}-list-${i}`}
                            className={'detailsTab__listDetails'}
                        >
                            <DetailItem flag={dataState[e].clientType} />
                            <DetailItem
                                flag="Razón social: "
                                details={fullnames(dataState[e])}
                            />
                            <DetailItem
                                flag={`${searchNameOfDocumentType(dataState[e].typeDoc)}: `}
                                details={dataState[e].nroDoc}
                            />
                            <DetailItem
                                flag={`Email: `}
                                details={dataState[e].email}
                                className="email"
                            />
                            <DetailItem
                                flag={`Giro: `}
                                details={dataState[e].giro}
                            />
                            <DetailItem
                                flag={`Celular: `}
                                details={dataState[e].phone}
                            />
                            <DetailItem
                                flag={`Teléfono: `}
                                details={dataState[e].cellphone}
                            />
                        </div>
                    )
                )
            })
        } else if (
            (assured != undefined &&
                Object.keys(assured).length > 0 &&
                (contratant === undefined ||
                    Object.keys(contratant).length === 0)) ||
            Object.values(assured)[1] === Object.values(contratant)[1]
        ) {
            //Cuando solo existe un asegurado
            return (
                <div className={'detailsTab__listDetails'}>
                    <DetailItem flag={entriesAsegurado[1].clientType} />
                    <DetailItem
                        flag="Nombre: "
                        details={fullnames(entriesAsegurado[1])}
                    />
                    <DetailItem
                        flag={`${searchNameOfDocumentType(entriesAsegurado[1].typeDoc)}: `}
                        details={entriesAsegurado[1].nroDoc}
                    />
                    <DetailItem
                        flag="Fecha de nacimiento: "
                        details={entriesAsegurado[1].birthday}
                    />
                    {entriesAsegurado[0] === 'assured' && (
                        <DetailItem
                            flag="Perfil de inversión: "
                            details={cmProfile}
                        />
                    )}
                    {
                        investmentPortfolio && (
                            <DetailItem
                                flag="Portafolio sugerido: "
                                details={investmentPortfolio}
                            />
                        )
                    }
                </div>
            )
        }
    }

    return (
        <>
            {
                //Si se envía list como true entonces:
                list && (
                    <div className="detailsTab">
                        {profileListCase()}
                        <a
                            className={'detailsTab__clearList'}
                            onClick={onClick}
                        >
                            <img src={limpiarIcon} /> Limpiar Datos
                        </a>
                    </div>
                )
                //Fin de la lista
            }
            {
                //Detalles no listados
                !list &&
                    (Object.keys(dataState).length > 1 &&
                        contratante && ( (contratante.names && contratante.names !== asegurado.names) ||
                        contratante.companyName
                        ) ? (
                        <div className="detailsTab">
                            <>
                                <div className="detailsTab__tabs">
                                    {Object.keys(dataState)
                                        .reverse()
                                        .map((e, i) => {
                                            return (
                                                dataState[e] && (
                                                    <TabTitle
                                                        key={`${e}-${i}`}
                                                        id={
                                                            dataState[e]
                                                                .clientType
                                                        }
                                                        value={e}
                                                        onClick={() =>
                                                            setSelected(e)
                                                        }
                                                        defaultChecked={
                                                            selected === e
                                                                ? true
                                                                : null
                                                        }
                                                    />
                                                )
                                            )
                                        })}
                                </div>
                                <div className="detailsTab__details">
                                    <DetailItem
                                        flag={dataState[selected].companyName ? 'Compañia: ' : 'Nombre: '}
                                        details={fullnames(dataState[selected])}
                                    />
                                    <DetailItem
                                        flag={`${searchNameOfDocumentType(dataState[selected].typeDoc)}: `}
                                        details={dataState[selected].nroDoc}
                                    />
                                    {selected === 'contratant' ? (
                                        <DetailItem
                                            flag="Perfil de inversión: "
                                            details={cmProfile}
                                        />
                                    ) : null}
                                    {
                                        investmentPortfolio && (
                                            <DetailItem
                                                flag="Portafolio sugerido: "
                                                details={investmentPortfolio}
                                            />
                                        )
                                    }
                                </div>
                                <a
                                    className={'detailsTab__clear isTabs'}
                                    onClick={onClick}
                                >
                                    Limpiar Datos <img src={limpiarIcon} />
                                </a>
                            </>
                        </div>
                    ) : (
                        asegurado && (
                            <div className="detailsTab">
                                {/* inicia */}
                                {entriesAsegurado[1] && (
                                    <div className="detailsTab__details">
                                        <DetailItem
                                            flag={
                                                entriesAsegurado[1] &&
                                                entriesAsegurado[1].clientType
                                            }
                                        />
                                        <DetailItem />
                                        {asegurado &&
                                            entriesAsegurado &&
                                            entriesAsegurado[1] && (
                                                <DetailItem
                                                    flag="Nombre: "
                                                    details={fullnames(
                                                        entriesAsegurado[1]
                                                    )}
                                                />
                                            )}
                                        <DetailItem
                                            flag={
                                                entriesAsegurado[1] &&
                                                entriesAsegurado[1].typeDoc ===
                                                    '2'
                                                    ? 'DNI: ' :
                                                    entriesAsegurado[1] &&
                                                entriesAsegurado[1].typeDoc === '3' ? 
                                                    'PASAPORTE: ' : 'CE'
                                            }
                                            details={
                                                entriesAsegurado[1] &&
                                                entriesAsegurado[1].nroDoc
                                            }
                                        />
                                        {entriesAsegurado[0] &&
                                        entriesAsegurado[0] === 'assured' ? (
                                            <DetailItem
                                                flag="Perfil de inversión: "
                                                details={cmProfile}
                                            />
                                        ) : null}
                                        {
                                            investmentPortfolio && (
                                                <DetailItem
                                                    flag="Portafolio sugerido: "
                                                    details={investmentPortfolio}
                                                />
                                            )
                                        }
                                    </div>
                                )}
                                {/* finaliza */}
                                <a
                                    className={'detailsTab__clear'}
                                    onClick={onClick}
                                >
                                    <img src={limpiarIcon} /> Limpiar Datos 
                                </a>
                            </div>
                        )
                    ))
            }
        </>
    )
}
export default DetailsTab
